module.exports = __webpack_public_path__ + "assets/img/4_140_big.112d2ba6.jpg";